const NODE_ENV = "dev";
export const Config = {
  dev: {
    PROVIDER: import.meta.env.VITE_PROVIDER,
    FORMULARIO_POSVENDAS: import.meta.env.VITE_FORMULARIO_POSVENDAS,
    AWS_API_PESSOAS: import.meta.env.VITE_API_PESSOAS,
    PROGALI_URL_BASE: import.meta.env.VITE_URL_BASE,
    AWS_API_BASE: import.meta.env.VITE_API_BASE,
    AWS_API_URL: import.meta.env.VITE_API_V1,
    AWS_API_URL_V2: import.meta.env.VITE_API_V2,
    URL_S3: import.meta.env.VITE_S3_PROGALI,
    CLIENTE: import.meta.env.VITE_CLIENTE,
    AMBIENTE: import.meta.env.VITE_ENV,
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    API_DOMAIN: import.meta.env.VITE_API_DOMAIN,
    APIS: {
      CALENDARIO: "https://p5yh4avnae.execute-api.sa-east-1.amazonaws.com",
    },
  },
  prod: {
    PROVIDER: import.meta.env.VITE_PROVIDER,
    FORMULARIO_POSVENDAS: import.meta.env.VITE_FORMULARIO_POSVENDAS,
    AWS_API_PESSOAS: import.meta.env.VITE_API_PESSOAS,
    AWS_API_BASE: import.meta.env.VITE_API_BASE,
    AWS_API_URL: import.meta.env.VITE_API_V1,
    PROGALI_URL_BASE: import.meta.env.VITE_URL_BASE,
    AWS_API_URL_V2: import.meta.env.VITE_API_V2,
    URL_S3: import.meta.env.VITE_S3_PROGALI,
    CLIENTE: import.meta.env.VITE_CLIENTE,
    AMBIENTE: import.meta.env.VITE_ENV,
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    API_DOMAIN: import.meta.env.VITE_API_DOMAIN,
    APIS: {
      CALENDARIO: "https://p5yh4avnae.execute-api.sa-east-1.amazonaws.com",
    },
  },
};

export default Config[NODE_ENV];
